import React from 'react';
import AdminDashboard from './AdminDashboard';

function App() {
  return <AdminDashboard />;
}

export default App;
